module.exports = __webpack_public_path__ + "img/motor_no19.9cd7d1bc.jpg";